import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useFeature } from '@core/Utils/hooks'
import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import {
  fetchRacePendingTicketsCount,
  PendingTicketsCountResponse,
} from '@core/Data/Account/PendingTicketsCount/helpers/api'
import { racingPendingTicketsPollingQuery } from '@core/Data/Account/PendingTicketsCount/helpers/queries'
import { FeatureFlags } from '@mobi/settings'

const racePendingTicketsCacheQueryKey = [...queryKeys.pendingTicketsCount, 'cached']

export const useCachedRacingPendingTicketsCount = ({ enabled }: { enabled: boolean }) => {
  const isAppHeaderPendingBetsFeatureActive = useFeature(
    FeatureFlags.PENDING_BETS_BUTTON_IN_APP_HEADER.key
  )

  const { data: pendingTicketsCount } = useQuery(
    (isAppHeaderPendingBetsFeatureActive
      ? { ...racingPendingTicketsPollingQuery, enabled }
      : {
          queryKey: [racePendingTicketsCacheQueryKey],
          queryFn: fetchRacePendingTicketsCount,
          enabled,
          staleTime: 1_000 * 60 * 30,
        }) as UseQueryOptions
  )

  return (pendingTicketsCount as PendingTicketsCountResponse)?.pendingTicketsCount ?? 0
}

export const clearCachedRacingPendingTicketsCount = () => {
  const queryKey = racePendingTicketsCacheQueryKey
  queryClient.removeQueries({ queryKey: [queryKey], exact: true })
}
